import { c as _c } from "react/compiler-runtime";
import React from "react";
import EmbedIFrameAutoHeight from "./EmbedIFrameAutoHeight";
export interface EmbedIFrameProps {
  url: string;
  title?: string;
  height?: string;
  width?: string;
  allow?: string;
  sandbox?: string;
}
function normalizeDimension(value: string | undefined, fallback: string): string {
  if (!value) return fallback;
  const trimmed = String(value).trim();
  if (!trimmed) return fallback;
  return /^\d+$/.test(trimmed) ? `${trimmed}px` : trimmed;
}
export default function EmbedIFrame(props) {
  const $ = _c(21);
  const {
    url,
    title,
    height,
    width,
    allow,
    sandbox
  } = props;
  if (!url) {
    return null;
  }
  let t0;
  if ($[0] !== width) {
    t0 = normalizeDimension(width, "100%");
    $[0] = width;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const normalizedWidth = t0;
  const hasExplicitHeight = typeof height === "string" && height.trim().length > 0;
  if (!hasExplicitHeight) {
    let t1;
    if ($[2] !== allow || $[3] !== normalizedWidth || $[4] !== sandbox || $[5] !== title || $[6] !== url) {
      t1 = <div className="embed-iframe-container"><EmbedIFrameAutoHeight url={url} title={title} width={normalizedWidth} allow={allow} sandbox={sandbox} /></div>;
      $[2] = allow;
      $[3] = normalizedWidth;
      $[4] = sandbox;
      $[5] = title;
      $[6] = url;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  let t1;
  if ($[8] !== height) {
    t1 = normalizeDimension(height, "600px");
    $[8] = height;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const normalizedHeight = t1;
  const t2 = sandbox as any;
  let t3;
  if ($[10] !== normalizedHeight || $[11] !== normalizedWidth) {
    t3 = {
      border: 0,
      width: normalizedWidth,
      height: normalizedHeight
    };
    $[10] = normalizedHeight;
    $[11] = normalizedWidth;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== allow || $[14] !== normalizedHeight || $[15] !== normalizedWidth || $[16] !== t2 || $[17] !== t3 || $[18] !== title || $[19] !== url) {
    t4 = <div className="embed-iframe-container"><iframe src={url} title={title} width={normalizedWidth} height={normalizedHeight} allow={allow} sandbox={t2} loading="lazy" referrerPolicy="no-referrer-when-downgrade" style={t3} /></div>;
    $[13] = allow;
    $[14] = normalizedHeight;
    $[15] = normalizedWidth;
    $[16] = t2;
    $[17] = t3;
    $[18] = title;
    $[19] = url;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}